import React, { useState } from 'react'; // Import useState for managing dropdown state
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import './Header.css';

const Header = () => {
    const navigate = useNavigate(); // Hook to navigate pages
    const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State to manage dropdown visibility

    const handleScrollToSection = (e, sectionId) => {
        e.preventDefault();
        navigate('/'); // Navigate to the homepage
        setTimeout(() => {
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' }); // Scroll to the section after navigation
            }
        }, 500); // Delay to ensure the page has loaded before scrolling
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen); // Toggle dropdown visibility
    };

    return (
        <header className="header">
            <div className="logo">
                <img src="/pictures/HGC-logo3.png" width="400" alt="Dental Clinic Logo" />
            </div>
            <nav className="nav">
                <ul>
                    <li>
                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                navigate('/');
                            }}
                        >
                            Home
                        </a>
                    </li>
                    <li>
                        <a href="#aboutus-container" onClick={(e) => handleScrollToSection(e, 'aboutus-container')}>
                            About Us
                        </a>
                    </li>
                    <li>
                        <a href="#services-content" onClick={(e) => handleScrollToSection(e, 'services-content')}>
                            Our Services
                        </a>
                    </li>
                    <li>
                        <a href="#contact-us-content" onClick={(e) => handleScrollToSection(e, 'contact-us-content')}>
                            Contact Us
                        </a>
                    </li>
                </ul>
            </nav>
            <div className="auth">
                <a href="/login" className="c-button c-button--gooey">
                    Sign In
                    <div className="c-button__blobs">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </a>
            </div>
            {/* Hamburger menu for mobile */}
            <div className="hamburger" onClick={toggleDropdown}>
                &#9776; {/* Hamburger icon */}
            </div>
            {/* Dropdown menu for mobile */}
            <div className={`header-dropdown ${isDropdownOpen ? 'active' : ''}`}>
                <ul>
                    <li>
                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                navigate('/');
                                toggleDropdown(); // Close dropdown after navigation
                            }}
                        >
                            Home
                        </a>
                    </li>
                    <li>
                        <a
                            href="#aboutus-container"
                            onClick={(e) => {
                                handleScrollToSection(e, 'aboutus-container');
                                toggleDropdown(); // Close dropdown after navigation
                            }}
                        >
                            About Us
                        </a>
                    </li>
                    <li>
                        <a
                            href="#services-content"
                            onClick={(e) => {
                                handleScrollToSection(e, 'services-content');
                                toggleDropdown(); // Close dropdown after navigation
                            }}
                        >
                            Our Services
                        </a>
                    </li>
                    <li>
                        <a
                            href="#contact-us-content"
                            onClick={(e) => {
                                handleScrollToSection(e, 'contact-us-content');
                                toggleDropdown(); // Close dropdown after navigation
                            }}
                        >
                            Contact Us
                        </a>
                    </li>
                </ul>
            </div>
            {/* SVG Filter for gooey effect */}
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" style={{ display: 'block', height: 0, width: 0 }}>
                <defs>
                    <filter id="goo">
                        <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur"></feGaussianBlur>
                        <feColorMatrix
                            in="blur"
                            mode="matrix"
                            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
                            result="goo"
                        ></feColorMatrix>
                        <feBlend in="SourceGraphic" in2="goo"></feBlend>
                    </filter>
                </defs>
            </svg>
        </header>
    );
};

export default Header;